import { COLORS, RANGES, UNITS, WORKTOPS } from './cloudinaryImages'
import { RANGE_PRICES, WORKTOP_PRICES } from './prices'

const sections = [
  {
    id: 'range',
    type: 'range',
    title: 'Köksmodeller',
    shortTitle: 'Kök',
    description: 'Välj din köksmodell.',
    tooltip: {
      title: 'Våra köksmodeller',
      description: [
        'Vi erbjuder ett brett sortiment av olika köksmodeller i lantlig, klassisk och modern stil. Priset kan variera för samma modell beroende på färg- och materialval.',
        'Med vår finansieringslösning  kan du välja att betala lite i taget.',
      ],
    },
    cards: [
      {
        title: 'Arkitekt Plus',
        collection: 'Marbodal',
        description:
          'Arkitekt plus kan anta olika stilar beroende på styling. Köksluckan fungerar fint med och utan handtag. Finns ek och samtliga kulörer i vår Jordnära kollektion.',
        colors: COLORS.arkitektPlus,
        prices: {
          small: RANGE_PRICES.arkitektPlus[0],
          medium: RANGE_PRICES.arkitektPlus[1],
          large: RANGE_PRICES.arkitektPlus[2],
        },
        image: RANGES.arkitektPlus,
      },
      {
        title: 'Signatur Ekbacken',
        collection: 'Marbodal',
        description:
          'Signatur Ekbacken är ett brun fanérat ek kök med ett formspråk inspirerat av naturen som formgivare.',
        colors: COLORS.signaturEkbacken,
        prices: {
          small: RANGE_PRICES.signaturEkbacken[0],
          medium: RANGE_PRICES.signaturEkbacken[1],
          large: RANGE_PRICES.signaturEkbacken[2],
        },
        image: RANGES.signaturEkbacken,
      },
      {
        title: 'Fagerö',
        collection: 'Marbodal',
        description:
          'Fagerö är ett kök i lantlig stil som finns i alla kulörer i vår Jordnära kollektion.',
        colors: COLORS.fagero,
        prices: {
          small: RANGE_PRICES.fagero[0],
          medium: RANGE_PRICES.fagero[1],
          large: RANGE_PRICES.fagero[2],
        },
        image: RANGES.fagero,
      },
      {
        title: 'Form',
        collection: 'Marbodal',
        description:
          'Form är ett inbjudande kök som kan stylas i alla stilar. Finns i samtliga kulörer i vår Jordnära kollektion.',
        colors: COLORS.form,
        prices: {
          small: RANGE_PRICES.form[0],
          medium: RANGE_PRICES.form[1],
          large: RANGE_PRICES.form[2],
        },
        image: RANGES.form,
      },
      {
        title: 'Lindö',
        collection: 'Marbodal',
        description:
          'Lindö har en klassisk exklusiv ramlucka med brett färgval. Av alla våra kök är Lindö det som har mest profilerad ram och spegel.',
        colors: COLORS.lindo,
        prices: {
          small: RANGE_PRICES.lindo[0],
          medium: RANGE_PRICES.lindo[1],
          large: RANGE_PRICES.lindo[2],
        },
        image: RANGES.lindo,
      },
      {
        title: 'Viken',
        collection: 'Marbodal',
        description:
          'Viken är ett minimalistiskt kök med integrerat grepp i luckan som skapar ett effektfullt linjespel. Ett snyggt och handtagslöst kök.',
        colors: COLORS.viken,
        prices: {
          small: RANGE_PRICES.viken[0],
          medium: RANGE_PRICES.viken[1],
          large: RANGE_PRICES.viken[2],
        },
        image: RANGES.viken,
      },
      {
        title: 'Ramsvik',
        collection: 'Marbodal',
        description:
          'Ramsvik är ett klassiskt kök i svartbets, ek. Skapa modern shakerstil med Ramsvik, stor köksö och knopplist.',
        colors: COLORS.ramsvik,
        prices: {
          small: RANGE_PRICES.ramsvik[0],
          medium: RANGE_PRICES.ramsvik[1],
          large: RANGE_PRICES.ramsvik[2],
        },
        image: RANGES.ramsvik,
      },
      {
        title: 'Malevik',
        collection: 'Marbodal',
        description:
          'Malevik är ett modernt och minimalistiskt kök med möbelkänsla i tålig MFC. Köksluckan har ett trämönster där strukturen inger en levande träkänsla.',
        colors: COLORS.malevik,
        prices: {
          small: RANGE_PRICES.malevik[0],
          medium: RANGE_PRICES.malevik[1],
          large: RANGE_PRICES.malevik[2],
        },
        image: RANGES.malevik,
      },
    ],
  },
  {
    id: 'units',
    title: 'Storleken påverkar priset',
    shortTitle: 'Storleken påverkar priset',
    type: 'units',
    description: 'Avser snittpris på kök utan vitvaror, bänkskiva eller installation.',
    tooltip: {
      title: 'Köksstorlekar',
      description: [
        'I ett mindre kök, < 10 m2,  får du exv. plats med 5 underskåp, 3 väggskåp, 1 högskåp.',
        'I ett vinkelkök, 10-20 m2, ryms exv. 8 underskåp, 5 väggskåp, 2 högskåp.',
        'I ett kök med köksö, < 20 m2, får du plats med exv. 12 underskåp, 8 väggskåp, 3 högskåp samt köksö.',
      ],
    },
    cards: [
      {
        type: 'small',
        title: 'Mindre kök',
        price: 0,
        image: UNITS.small,
      },
      {
        type: 'medium',
        title: 'Vinkelkök',
        price: 0,
        image: UNITS.medium,
      },
      {
        type: 'large',
        title: 'Kök med köksö',
        price: 0,
        image: UNITS.large,
      },
    ],
  },
  {
    id: 'worktops',
    title: 'Bänkskivor',
    type: 'simple',
    description: 'Välj vilken typ av bänkskiva du vill ha.',
    tooltip: {
      title: 'Våra bänkskivor',
      description: [
        'Välj mellan laminat, massivt trä och granit och kombinera med köksstorlek för att få ett ungefärligt pris-estimat.',
        'Vi erbjuder en mängd olika bänkskivor i varje material, så du kan välja den faktiska bänkskivan i ett senare skede.',
      ],
    },
    cards: [
      {
        title: 'Laminat',
        description:
          'Laminatbänkskivorna har ett brett sortiment av en mängd olika ytor, mönster och färger.',
        prices: {
          small: WORKTOP_PRICES.laminate[0],
          medium: WORKTOP_PRICES.laminate[1],
          large: WORKTOP_PRICES.laminate[2],
        },
        image: WORKTOPS.laminate,
      },
      {
        title: 'Massivt Trä',
        description:
          'Bänkskivor i massivt trä är både levande och varmt, genuint och vackert, det tål att åldras.',
        prices: {
          small: WORKTOP_PRICES.solidTimber[0],
          medium: WORKTOP_PRICES.solidTimber[1],
          large: WORKTOP_PRICES.solidTimber[2],
        },
        image: WORKTOPS.wood,
      },
      {
        title: 'Rostfri',
        description:
          'En rostfri bänkskiva är ett snyggt, lättskött och tåligt alternativ till ditt kök.',
        prices: {
          small: WORKTOP_PRICES.stainless[0],
          medium: WORKTOP_PRICES.stainless[1],
          large: WORKTOP_PRICES.stainless[2],
        },
        image: WORKTOPS.stainless,
      },
      {
        title: 'Granit',
        description:
          'De vackra bänkskivorna i granit finns i en mängd olika lyxiga putsningar som passar till alla kök. Varje lager är unikt, så du kan vara säker på att även ditt kök blir det.',
        prices: {
          small: WORKTOP_PRICES.granite[0],
          medium: WORKTOP_PRICES.granite[1],
          large: WORKTOP_PRICES.granite[2],
        },
        image: WORKTOPS.granite,
      },
    ],
  },
  {
    id: 'estimate',
    title: 'Estimat',
    type: 'summary',
    description: '',
    tooltip: {},
  },
]

export default sections
